export class RequestedObject {
  constructor(
    public id: string,
    public key: string,
    public value: string,
  ) {
  }
}
